import { api } from '@/lib/api'
import type { Stage, StageRequest, StageUpdateRequest, StageOwner } from './types'

/** A bare string is a configuration code (back-compat); otherwise an explicit owner. */
function base(owner: string | StageOwner): string {
  const o: StageOwner = typeof owner === 'string' ? { kind: 'configuration', code: owner } : owner
  return o.kind === 'product'
    ? `/api/products/${o.code}/stages`
    : `/api/configurations/${o.code}/stages`
}

export async function listStages(owner: string | StageOwner): Promise<Stage[]> {
  const r = await api.get<Stage[]>(base(owner))
  return r.data
}

export async function createStage(owner: string | StageOwner, payload: StageRequest): Promise<Stage> {
  const r = await api.post<Stage>(base(owner), payload)
  return r.data
}

export async function updateStage(owner: string | StageOwner, code: string, payload: StageUpdateRequest): Promise<Stage> {
  const r = await api.put<Stage>(`${base(owner)}/${code}`, payload)
  return r.data
}

export async function deleteStage(owner: string | StageOwner, code: string): Promise<void> {
  await api.delete(`${base(owner)}/${code}`)
}

export async function reorderStages(owner: string | StageOwner, codes: string[]): Promise<void> {
  await api.put(`${base(owner)}/order`, { codes })
}
